import Banner from "../pages/Banner";
import Login from "../pages/Login";
import Op from "../pages/Op";
import Feed from "../pages/Feed";
import StreamerInformation from "../pages/StreamerInformation";
import StreamerJoin from "../pages/StreamerJoin";
import StreamerJoinNew from "../pages/StreamerJoinNew";
import StreamerInformationCompleteNew from "../pages/StreamerInformationCompleteNew";
import Feedback from "../pages/Feedback";
import Notices from "../pages/Notices";
import AutoAnwser from "../pages/AutoAnwser";
import HotManage from "../pages/HotManage";
import Contact from "../pages/Contact";
import UploadMedia from "../pages/UploadMedia";
import GoodsReview from "../pages/GoodsReview";
import MediaReview from "../pages/MediaReview";
import CommentsReview from "../pages/CommentsReview";
import OrdersQuerry from "../pages/OrdersQuerry";
import StreamerVerification from "../pages/StreamerVerification";
import ImageMachineReview from "../pages/ImageMachineReview";
import TextMachineReview from "../pages/TextMachineReview";
import StreamerTextMachineReview from "../pages/StreamerTextMachineReview";
import ManualRechargeAndWithdrawal from "../pages/ManualRechargeAndWithdrawal";
import CreateAndEditPost from "../pages/CreateAndEditPost";
import TopPosts from "../pages/TopPosts";
import PostMachineReview from "../pages/PostMachineReview";
import GetPhoneNumber from "../pages/GetPhoneNumber";
import Refund from "../pages/Refund";
import BlockUser from "../pages/BlockUser";
import ZonePostMachineReview from "../pages/ZonePostMachineReview";
import GuildMachineReview from "../pages/GuildMachineReview";
import StreamerSpace from "../pages/StreamerSpace";
import SpaceMemberRefundQuerry from "../pages/SpaceMemberRefundQuerry";
import QuerryMidAndUserId from "../pages/QuerryMidAndUserId";
import EditSpacePost from "../pages/EditSpacePost";
import StreamerImageMachineReview from "../pages/StreamerImageMachineReview";
import StreamerNickTextMachineReview from "../pages/StreamerNickTextMachineReview";
import StreamerVideoMachineReview from "../pages/StreamerVideoMachineReview";
import RollbackUserLeaveSpace from "../pages/RollbackUserLeaveSpace";
import RollbackUserRefundSpaceStatus from "../pages/RollbackUserRefundSpaceStatus/index";
import WithdrawFreeze from "../pages/WithdrawFreeze";

const routes = [
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/",
    element: <Op />,
    children: [
      {
        path: "banner/*",
        element: <Banner />,
      },
      {
        path: "feed/*",
        element: <Feed />,
      },
      {
        path: "streamerInformation/*",
        element: <StreamerInformation />,
      },
      {
        path: "streamerJoin/*",
        element: <StreamerJoin />,
      },
      {
        path: "streamerJoinNew/*",
        element: <StreamerJoinNew />,
      },
      {
        path: "streamerInformationCompleteNew/*",
        element: <StreamerInformationCompleteNew />,
      },
      {
        path: "streamerVerification/*",
        element: <StreamerVerification />,
      },
      {
        path: "notices/*",
        element: <Notices />,
      },
      {
        path: "autoAnswer/*",
        element: <AutoAnwser />,
      },
      {
        path: "hotManage/*",
        element: <HotManage />,
      },
      {
        path: "feedback/*",
        element: <Feedback />,
      },
      {
        path: "contact/*",
        element: <Contact />,
      },
      {
        path: "uploadMedia/*",
        element: <UploadMedia />,
      },
      {
        path: "goodsReview/*",
        element: <GoodsReview />,
      },
      {
        path: "mediaReview/*",
        element: <MediaReview />,
      },
      {
        path: "commentsReview/*",
        element: <CommentsReview />,
      },
      {
        path: "ordersQuerry/*",
        element: <OrdersQuerry />,
      },
      {
        path: "imageMachineReview/*",
        element: <ImageMachineReview />,
      },
      {
        path: "textMachineReview/*",
        element: <TextMachineReview />,
      },
      {
        path: "streamerTextMachineReview/*",
        element: <StreamerTextMachineReview />,
      },
      {
        path: "manualRechargeAndWithdrawal/*",
        element: <ManualRechargeAndWithdrawal />,
      },
      {
        path: "createAndEditPost/*",
        element: <CreateAndEditPost />,
      },
      {
        path: "topPosts/*",
        element: <TopPosts />,
      },
      {
        path: "postMachineReview/*",
        element: <PostMachineReview />,
      },
      {
        path: "getPhoneNumber/*",
        element: <GetPhoneNumber />,
      },
      {
        path: "refund/*",
        element: <Refund />,
      },
      {
        path: "blockUser/*",
        element: <BlockUser />,
      },
      {
        path: "zonePostMachineReview/*",
        element: <ZonePostMachineReview />,
      },
      {
        path: "guildMachineReview/*",
        element: <GuildMachineReview />,
      },
      {
        path: "streamerSpace/*",
        element: <StreamerSpace />,
      },
      {
        path: "spaceMemberRefundQuerry/*",
        element: <SpaceMemberRefundQuerry />,
      },
      {
        path: "querryMidAndUserId/*",
        element: <QuerryMidAndUserId />,
      },
      {
        path: "editSpacePost/*",
        element: <EditSpacePost />,
      },
      {
        path: "streamerImageMachineReview/*",
        element: <StreamerImageMachineReview />,
      },
      {
        path: "streamerNickTextMachineReview/*",
        element: <StreamerNickTextMachineReview />,
      },
      {
        path: "streamerVideoMachineReview/*",
        element: <StreamerVideoMachineReview />,
      },
      {
        path: "rollbackUserLeaveSpace/*",
        element: <RollbackUserLeaveSpace />,
      },
      {
        path: "rollbackUserRefundSpaceStatus/*",
        element: <RollbackUserRefundSpaceStatus />,
      },
      {
        path: "withdrawFreeze/*",
        element: <WithdrawFreeze />,
      },
    ],
  },
];

export default routes;
